<div class="column">
    <div (click)="showImage(image)" *ngFor="let image of fileElements" [class.back]="image.name === '...'" [class.folder]="image.folder && image.name !== '...'">
        <img [class.folder-icon]="image.folder" [src]="image.url" alt="{{image.name}}">
        <span *ngIf="image.folder">{{image.name}}</span>
    </div>
</div>
